export default {
  "fr": {
    "editor_ziggu": {
      "actions": {
        "showLess": "Montrer moins",
        "showMore": "Montrer plus"
      },
      "placeholders": {
        "content": "Commencer à écrire..",
        "link": "Taper / coller un lien"
      }
    }
  }
}